<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
       <el-form-item label="自提点名称：" prop="pickupName">
          <el-input style="width: 424px;" v-model="ruleForm.pickupName" placeholder="请输入自提点名称"></el-input>
        </el-form-item>
        <el-form-item label="自提点电话：" prop="pickupPhone">
          <el-input style="width: 424px;" v-model="ruleForm.pickupPhone" placeholder="请输入自提点电话"></el-input>
        </el-form-item>
        <el-form-item label="自提点地址：" prop="pickupDetail">
          <el-input style="width: 424px;" v-model="ruleForm.pickupDetail" placeholder="地址输入格式：省-市-区-详细地址(详细地址不带-)"></el-input>
        </el-form-item>
        <el-form-item label="经度：" prop="pickupLongitude">
          <el-input style="width: 424px;" v-model="ruleForm.pickupLongitude" placeholder="请输入经度"></el-input>
          <a class="color-theme" style="display: inline-block;" href="https://lbs.qq.com/tool/getpoint/index.html" target="_blank">点击获取</a>
        </el-form-item>
        <el-form-item label="纬度：" prop="pickupLatitude">
          <el-input style="width: 424px;" v-model="ruleForm.pickupLatitude" placeholder="请输入纬度"></el-input>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveSeleniumJourneyConfig, fetchSeleniumJourneyConfigDetail } from '@/api/journeySetting'
export default {
  name: 'Pickup',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      ruleForm: {
         pickupName:'',
         pickupPhone:'',
         pickupDetail:'',
         pickupLongitude:'',
         pickupLatitude:''
      },
      rules: {
        pickupName: [
          { required: true, message: '请输入核销人名称', trigger: 'blur' }
        ],
        pickupPhone: [
          { required: true, message: '请输入自提点电话', trigger: 'blur' }
        ],
        pickupDetail: [
          { required: true, message: '请输入自提点地址', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    fetchSeleniumJourneyConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.pickupName = data.pickupName
        that.ruleForm.writeOffPhone = data.writeOffPhone
        that.ruleForm.pickupDetail = data.pickupDetail
        that.ruleForm.pickupLongitude = data.pickupLongitude
        that.ruleForm.pickupLatitude = data.pickupLatitude
      }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let pickupName = that.ruleForm.pickupName
      let pickupPhone = that.ruleForm.pickupPhone
      let pickupDetail = that.ruleForm.pickupDetail
      let pickupLongitude = that.ruleForm.pickupLongitude
      let pickupLatitude = that.ruleForm.pickupLatitude
      if(pickupName == ''){
        this.$message.error('请输入自提点名称')
        return false
      }
      if(pickupPhone == ''){
        this.$message.error('请输入自提点电话')
        return false
      }
      if(pickupDetail == ''){
        this.$message.error('请输入自提点地址')
        return false
      }
      that.fullscreenLoading = true
      saveSeleniumJourneyConfig({pickupName:pickupName,pickupPhone:pickupPhone,pickupDetail:pickupDetail,pickupLongitude:pickupLongitude,pickupLatitude:pickupLatitude}).then((res) => {
         that.fullscreenLoading = false
         that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/JourneyPickup.vue